import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.css']
})
export class ModalComponent implements OnInit {

  @Input() Titulo: string;
  @Input() Width: string = "90%";
  @Input() CloseCancelAction: any;
  @Input() OkAction: any;
  @Input() Ref: any;
  @Input() Tamanho: string = "400px";
  @Input() TitleOk:string = "Ok";
  @Input() TitleCancel:string = "Cancelar";
  @Input() ShowButtons: boolean = false;
  @Input() ShowButtonCancel: boolean = false;
  @Input() Top: string = "20%";
  constructor() { }

  ngOnInit() {
  }

}
